import MenuItem from "@material-ui/core/MenuItem";
import styles from "./styles";

import { withStyles } from "@material-ui/core/styles";

export default withStyles(styles)(MenuItem);
